module.exports = __webpack_public_path__ + "static/media/VE.e4d3e890.png";